<template lang="pug"></template>

<script>
export default {
    name: 'BotaoRelatorios',
    componentOptions: {
        title: 'Relatórios',
        actions: [
            [
                {
                    name: 'Relatórios',
                    iconClass: 'lyra-icon lyra-home',
                    showView: false,
                    action: 'abrirRelatorios',
                    route: 'adminRelatorios',
                    nameTranslationKey: 'mensagens.menuLateral.relatorios'
                }
            ]
        ]
    },

    methods: {
        abrirRelatorios() {
            if (this.$route.name !== 'adminRelatorios') {
                this.$router.push({ name: 'adminRelatorios' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
